// Generated by ReScript, PLEASE EDIT WITH CARE


function truncateWithMiddleEllipsis(str, maxLen) {
  if (str.length <= maxLen) {
    return str;
  }
  let len = str.length;
  let halfLen = (maxLen - 3 | 0) / 2 | 0;
  let startStr = str.slice(0, halfLen).trim();
  let endStr = str.slice(len - halfLen | 0, len).trim();
  return startStr + "..." + endStr;
}

function isEmptyOptionString(value) {
  if (value !== undefined) {
    return value.trim() === "";
  } else {
    return true;
  }
}

function stripEmptyString(string) {
  let string$1 = string.trim();
  if (string$1 === "") {
    return;
  } else {
    return string$1;
  }
}

export {
  truncateWithMiddleEllipsis,
  isEmptyOptionString,
  stripEmptyString,
}
/* No side effect */
